// removed by extract-text-webpack-plugin
module.exports = {"workerForm":"VQ5twzlhLS7t5k1u2tLxe","fetchCompleteDialog":"_2Y0xFOlhMX_YAAvnQEMh_v","CcusInfoTranscriptionAgreementDialog":"fjHaPO6lrdJx-u8TCABA2"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/componentStyle/workerForm/workerForm.scss
// module id = 212
// module chunks = 0